import { render, staticRenderFns } from "./RequestApprovalMenu.vue?vue&type=template&id=399415fe"
import script from "./RequestApprovalMenu.vue?vue&type=script&lang=js"
export * from "./RequestApprovalMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports